import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from 'vue';
import tippy, { Instance, Placement } from 'tippy.js';
import 'tippy.js/dist/tippy.css';

interface Props {
    text: string;
    theme?: string;
    arrow?: boolean;
    placement?: Placement;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTippyJS',
  props: {
    text: {},
    theme: {},
    arrow: { type: Boolean },
    placement: {}
  },
  setup(__props: any) {

const props = __props;

const tooltipElement = ref<HTMLElement | null>(null);
let tooltipInstance: Instance | null = null;

onMounted(() => {
    if (tooltipElement.value) {
        tooltipInstance = tippy(tooltipElement.value, {
            content: props.text,
            allowHTML: true,
            theme: props.theme || 'default',
            placement: props.placement || 'top',
            arrow: props.arrow || true
        });
    }
});

onBeforeUnmount(() => {
    if (tooltipInstance) {
        tooltipInstance.destroy();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "tooltipElement",
    ref: tooltipElement
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})